import { getService } from "../../axios/services";

export const getThesaurus = ({ origins, cancelToken }) =>
  getService({
    endpoint: "Thesaurus",
    api: "v2",
    params: { origins },
    options: { cancelToken },
  });
